// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getOnlineCourseDataEpic from './getOnlineCourseDataEpic';
import getOnlineCourseContentsDataEpic from './getOnlineCourseContentsDataEpic';
import getOnlineCourseNotesDataEpic from './getOnlineCourseNotesDataEpic';
import createOnlineCourseNoteEpic from './createOnlineCourseNoteEpic';
import deleteOnlineCourseNoteEpic from './deleteOnlineCourseNoteEpic';
import updateOnlineCourseNoteEpic from './updateOnlineCourseNoteEpic';
import updateOnlineCourseProgressEpic from './updateOnlineCourseProgressEpic';
import sendVisitedOnlineCourseEpic from './sendVisitedOnlineCourseEpic';

export default [
  getOnlineCourseDataEpic,
  getOnlineCourseContentsDataEpic,
  getOnlineCourseNotesDataEpic,
  createOnlineCourseNoteEpic,
  deleteOnlineCourseNoteEpic,
  updateOnlineCourseNoteEpic,
  updateOnlineCourseProgressEpic,
  sendVisitedOnlineCourseEpic
]
